import { autoserialize, autoserializeAs } from 'cerialize';

export class LoginModel {
  @autoserialize email?: string;
  @autoserialize password?: string;
  @autoserialize provider?: 'google';
  @autoserializeAs('id_token') idToken?: string;

  constructor(payload: LoginModel) {
    this.email = payload.email;
    this.password = payload.password;
    this.provider = payload.provider;
    this.idToken = payload.idToken;
  }
}

export interface ILoginModel {
  email: string;
  password: string;
}
